export const styles = theme => ({
    root: {
        marginTop: 20,
        "& h6": {
            fontWeight: 700,
        },
        "& svg": {
            float: "left",
            color: "#009",
            marginRight: 5,
            height: 18,
        }
    },
    sampleLink: {
        color: "#009",
        fontFamily: "newsGothic_demi,Arial,Verdana,Helvetica,sans-serif",
    }
});